'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ne_NP = require('../locale/ne_NP');

var _ne_NP2 = _interopRequireDefault(_ne_NP);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _ne_NP2['default'];